@if(mobileTheme$ | async; as mobileTheme) {
<app-config-mobile-app
  [theme]="mobileTheme"
  data-test-id="mobile-config-app"
></app-config-mobile-app>
} @else {
<app-spinner data-test-id="mobile-config-spinner"></app-spinner>
}
